export default defineNuxtRouteMiddleware(async () => {
  const nuxtApp = useNuxtApp()
  const locale = nuxtApp.$i18n.locale.value

  return navigateTo(`/${locale}/user-zone/bookings`)
})